import { Avatar, MessagesButton, UserName } from './userInfoSkeleton.styles';

const UserInfoSkeleton = () => {
  return (
    <div className="_px-5 _pb-5" role="status" aria-busy="true">
      <div className="_d-flex _align-items-center">
        <Avatar className="_rounded-circle _mr-4" />
        <UserName className="_rounded-pill" />
      </div>

      <MessagesButton className="_mt-5 _rounded-pill" />
    </div>
  );
};

export default UserInfoSkeleton;
